import { AppConfiguration } from './config';

export const environment: AppConfiguration = {
    production: false,
    appWebsite: 'https://buck-e.be',
    idpUrl: 'https://auth.staging.otzy.eu',
    idpClientId: 'c66e2e21-c06a-4711-9440-95cc27663cc5',
    icpDashboardUrl: 'https://dashboard.staging.otzy.eu',
    icpAppWebsite: 'https://app.staging.otzy.eu',
};
